export default __webpack_public_path__ + "static/media/11n.74d5ec75.jpg";